const styles = {
  container: {
    backgroundColor: "white",
    color: "rgb(51, 51, 51)",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    fontSize: 24,
    justifyContent: "center",
    marginTop: 50,
    padding: 30
  }
};

export default styles;
